import styled from 'styled-components';

const StoriesRootElement = styled.div`
    background: #f9f9f9;
    padding: 60px 0 48px 0;
    @media (max-width: 767px) {
        padding: 48px 0 35px 0;
    }
    .grid-col {
        grid-gap: 24px;
        grid-template-columns: 1fr 1fr 1fr;
        display: grid;
        @media (max-width: 1040px) {
            grid-template-columns: 1fr 1fr 1fr;
            @media (max-width: 991px) {
                grid-template-columns: 1fr 1fr;
                @media (max-width: 767px) {
                    grid-template-columns: 1fr;
                }
            }
        }
    }
    .card-action {
        width: 100%;
        border-radius: 8px;
        box-shadow:0px 0px 0px 1px rgba(0, 0, 0, 0.10) inset;
    }
    .default-card-image {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0;
        box-sizing: border-box;
        img {
            height: 100% !important;
            -o-object-fit: contain;
            object-fit: contain;
            width: 100%;
        }
    }
    .card-heading {
        -webkit-box-orient: vertical;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        overflow: hidden;
        text-overflow: -o-ellipsis-lastline;
        @media (max-width: 767px) {
            height: 46px;
        }
    }
    .card-desc {
        -webkit-box-orient: vertical;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        overflow: hidden;
        text-overflow: -o-ellipsis-lastline;
    }
`;
export default StoriesRootElement;
